export const CURRENCY_DETAILS_LIST = {
    "USD": {
        "symbol": "$",
        "nativeSymbol": "$",
        "code": "USD",
    },
    "CAD": {
        "symbol": "CA$",
        "nativeSymbol": "$",
        "code": "CAD",
    },
    "EUR": {
        "symbol": "€",
        "nativeSymbol": "€",
        "code": "EUR",
    },
    "AED": {
        "symbol": "AED",
        "nativeSymbol": "د.إ.‏",
        "code": "AED",
    },
    "AFN": {
        "symbol": "Af",
        "nativeSymbol": "؋",
        "code": "AFN",
    },
    "ALL": {
        "symbol": "ALL",
        "nativeSymbol": "Lek",
        "code": "ALL",
    },
    "AMD": {
        "symbol": "AMD",
        "nativeSymbol": "դր.",
        "code": "AMD",
    },
    "ARS": {
        "symbol": "AR$",
        "nativeSymbol": "$",
        "code": "ARS",
    },
    "AUD": {
        "symbol": "AU$",
        "nativeSymbol": "$",
        "code": "AUD",
    },
    "AZN": {
        "symbol": "man.",
        "nativeSymbol": "ман.",
        "code": "AZN",
    },
    "BAM": {
        "symbol": "KM",
        "nativeSymbol": "KM",
        "code": "BAM",
    },
    "BDT": {
        "symbol": "Tk",
        "nativeSymbol": "৳",
        "code": "BDT",
    },
    "BGN": {
        "symbol": "BGN",
        "nativeSymbol": "лв.",
        "code": "BGN",
    },
    "BHD": {
        "symbol": "BD",
        "nativeSymbol": "د.ب.‏",
        "code": "BHD",
    },
    "BIF": {
        "symbol": "FBu",
        "nativeSymbol": "FBu",
        "code": "BIF",
    },
    "BND": {
        "symbol": "BN$",
        "nativeSymbol": "$",
        "code": "BND",
    },
    "BOB": {
        "symbol": "Bs",
        "nativeSymbol": "Bs",
        "code": "BOB",
    },
    "BRL": {
        "symbol": "R$",
        "nativeSymbol": "R$",
        "code": "BRL",
    },
    "BWP": {
        "symbol": "BWP",
        "nativeSymbol": "P",
        "code": "BWP",
    },
    "BYN": {
        "symbol": "Br",
        "nativeSymbol": "руб.",
        "code": "BYN",
    },
    "BZD": {
        "symbol": "BZ$",
        "nativeSymbol": "$",
        "code": "BZD",
    },
    "CDF": {
        "symbol": "CDF",
        "nativeSymbol": "FrCD",
        "code": "CDF",
    },
    "CHF": {
        "symbol": "CHF",
        "nativeSymbol": "CHF",
        "code": "CHF",
    },
    "CLP": {
        "symbol": "CL$",
        "nativeSymbol": "$",
        "code": "CLP",
    },
    "CNY": {
        "symbol": "CN¥",
        "nativeSymbol": "CN¥",
        "code": "CNY",
    },
    "COP": {
        "symbol": "CO$",
        "nativeSymbol": "$",
        "code": "COP",
    },
    "CRC": {
        "symbol": "₡",
        "nativeSymbol": "₡",
        "code": "CRC",
    },
    "CVE": {
        "symbol": "CV$",
        "nativeSymbol": "CV$",
        "code": "CVE",
    },
    "CZK": {
        "symbol": "Kč",
        "nativeSymbol": "Kč",
        "code": "CZK",
    },
    "DJF": {
        "symbol": "Fdj",
        "nativeSymbol": "Fdj",
        "code": "DJF",
    },
    "DKK": {
        "symbol": "Dkr",
        "nativeSymbol": "kr",
        "code": "DKK",
    },
    "DOP": {
        "symbol": "RD$",
        "nativeSymbol": "RD$",
        "code": "DOP",
    },
    "DZD": {
        "symbol": "DA",
        "nativeSymbol": "د.ج.‏",
        "code": "DZD",
    },
    "EEK": {
        "symbol": "Ekr",
        "nativeSymbol": "kr",
        "code": "EEK",
    },
    "EGP": {
        "symbol": "EGP",
        "nativeSymbol": "ج.م.‏",
        "code": "EGP",
    },
    "ERN": {
        "symbol": "Nfk",
        "nativeSymbol": "Nfk",
        "code": "ERN",
    },
    "ETB": {
        "symbol": "Br",
        "nativeSymbol": "Br",
        "code": "ETB",
    },
    "GBP": {
        "symbol": "£",
        "nativeSymbol": "£",
        "code": "GBP",
    },
    "GEL": {
        "symbol": "GEL",
        "nativeSymbol": "GEL",
        "code": "GEL",
    },
    "GHS": {
        "symbol": "GH₵",
        "nativeSymbol": "GH₵",
        "code": "GHS",
    },
    "GNF": {
        "symbol": "FG",
        "nativeSymbol": "FG",
        "code": "GNF",
    },
    "GTQ": {
        "symbol": "GTQ",
        "nativeSymbol": "Q",
        "code": "GTQ",
    },
    "HKD": {
        "symbol": "HK$",
        "nativeSymbol": "$",
        "code": "HKD",
    },
    "HNL": {
        "symbol": "HNL",
        "nativeSymbol": "L",
        "code": "HNL",
    },
    "HRK": {
        "symbol": "kn",
        "nativeSymbol": "kn",
        "code": "HRK",
    },
    "HUF": {
        "symbol": "Ft",
        "nativeSymbol": "Ft",
        "code": "HUF",
    },
    "IDR": {
        "symbol": "Rp",
        "nativeSymbol": "Rp",
        "code": "IDR",
    },
    "ILS": {
        "symbol": "₪",
        "nativeSymbol": "₪",
        "code": "ILS",
    },
    "INR": {
        "symbol": "Rs",
        "nativeSymbol": "টকা",
        "code": "INR",
    },
    "IQD": {
        "symbol": "IQD",
        "nativeSymbol": "د.ع.‏",
        "code": "IQD",
    },
    "IRR": {
        "symbol": "IRR",
        "nativeSymbol": "﷼",
        "code": "IRR",
    },
    "ISK": {
        "symbol": "Ikr",
        "nativeSymbol": "kr",
        "code": "ISK",
    },
    "JMD": {
        "symbol": "J$",
        "nativeSymbol": "$",
        "code": "JMD",
    },
    "JOD": {
        "symbol": "JD",
        "nativeSymbol": "د.أ.‏",
        "code": "JOD",
    },
    "JPY": {
        "symbol": "¥",
        "nativeSymbol": "￥",
        "code": "JPY",
    },
    "KES": {
        "symbol": "Ksh",
        "nativeSymbol": "Ksh",
        "code": "KES",
    },
    "KHR": {
        "symbol": "KHR",
        "nativeSymbol": "៛",
        "code": "KHR",
    },
    "KMF": {
        "symbol": "CF",
        "nativeSymbol": "FC",
        "code": "KMF",
    },
    "KRW": {
        "symbol": "₩",
        "nativeSymbol": "₩",
        "code": "KRW",
    },
    "KWD": {
        "symbol": "KD",
        "nativeSymbol": "د.ك.‏",
        "code": "KWD",
    },
    "KZT": {
        "symbol": "KZT",
        "nativeSymbol": "тңг.",
        "code": "KZT",
    },
    "LBP": {
        "symbol": "LB£",
        "nativeSymbol": "ل.ل.‏",
        "code": "LBP",
    },
    "LKR": {
        "symbol": "SLRs",
        "nativeSymbol": "SL Re",
        "code": "LKR",
    },
    "LTL": {
        "symbol": "Lt",
        "nativeSymbol": "Lt",
        "code": "LTL",
    },
    "LVL": {
        "symbol": "Ls",
        "nativeSymbol": "Ls",
        "code": "LVL",
    },
    "LYD": {
        "symbol": "LD",
        "nativeSymbol": "د.ل.‏",
        "code": "LYD",
    },
    "MAD": {
        "symbol": "MAD",
        "nativeSymbol": "د.م.‏",
        "code": "MAD",
    },
    "MDL": {
        "symbol": "MDL",
        "nativeSymbol": "MDL",
        "code": "MDL",
    },
    "MGA": {
        "symbol": "MGA",
        "nativeSymbol": "MGA",
        "code": "MGA",
    },
    "MKD": {
        "symbol": "MKD",
        "nativeSymbol": "MKD",
        "code": "MKD",
    },
    "MMK": {
        "symbol": "MMK",
        "nativeSymbol": "K",
        "code": "MMK",
    },
    "MOP": {
        "symbol": "MOP$",
        "nativeSymbol": "MOP$",
        "code": "MOP",
    },
    "MUR": {
        "symbol": "MURs",
        "nativeSymbol": "MURs",
        "code": "MUR",
    },
    "MXN": {
        "symbol": "MX$",
        "nativeSymbol": "$",
        "code": "MXN",
    },
    "MYR": {
        "symbol": "RM",
        "nativeSymbol": "RM",
        "code": "MYR",
    },
    "MZN": {
        "symbol": "MTn",
        "nativeSymbol": "MTn",
        "code": "MZN",
    },
    "NAD": {
        "symbol": "N$",
        "nativeSymbol": "N$",
        "code": "NAD",
    },
    "NGN": {
        "symbol": "₦",
        "nativeSymbol": "₦",
        "code": "NGN",
    },
    "NIO": {
        "symbol": "C$",
        "nativeSymbol": "C$",
        "code": "NIO",
    },
    "NOK": {
        "symbol": "Nkr",
        "nativeSymbol": "kr",
        "code": "NOK",
    },
    "NPR": {
        "symbol": "NPRs",
        "nativeSymbol": "नेरू",
        "code": "NPR",
    },
    "NZD": {
        "symbol": "NZ$",
        "nativeSymbol": "$",
        "code": "NZD",
    },
    "OMR": {
        "symbol": "OMR",
        "nativeSymbol": "ر.ع.‏",
        "code": "OMR",
    },
    "PAB": {
        "symbol": "B/.",
        "nativeSymbol": "B/.",
        "code": "PAB",
    },
    "PEN": {
        "symbol": "S/.",
        "nativeSymbol": "S/.",
        "code": "PEN",
    },
    "PHP": {
        "symbol": "₱",
        "nativeSymbol": "₱",
        "code": "PHP",
    },
    "PKR": {
        "symbol": "PKRs",
        "nativeSymbol": "₨",
        "code": "PKR",
    },
    "PLN": {
        "symbol": "zł",
        "nativeSymbol": "zł",
        "code": "PLN",
    },
    "PYG": {
        "symbol": "₲",
        "nativeSymbol": "₲",
        "code": "PYG",
    },
    "QAR": {
        "symbol": "QR",
        "nativeSymbol": "ر.ق.‏",
        "code": "QAR",
    },
    "RON": {
        "symbol": "RON",
        "nativeSymbol": "RON",
        "code": "RON",
    },
    "RSD": {
        "symbol": "din.",
        "nativeSymbol": "дин.",
        "code": "RSD",
    },
    "RUB": {
        "symbol": "RUB",
        "nativeSymbol": "₽.",
        "code": "RUB",
    },
    "RWF": {
        "symbol": "RWF",
        "nativeSymbol": "FR",
        "code": "RWF",
    },
    "SAR": {
        "symbol": "SR",
        "nativeSymbol": "ر.س.‏",
        "code": "SAR",
    },
    "SDG": {
        "symbol": "SDG",
        "nativeSymbol": "SDG",
        "code": "SDG",
    },
    "SEK": {
        "symbol": "Skr",
        "nativeSymbol": "kr",
        "code": "SEK",
    },
    "SGD": {
        "symbol": "S$",
        "nativeSymbol": "$",
        "code": "SGD",
    },
    "SOS": {
        "symbol": "Ssh",
        "nativeSymbol": "Ssh",
        "code": "SOS",
    },
    "SYP": {
        "symbol": "SY£",
        "nativeSymbol": "ل.س.‏",
        "code": "SYP",
    },
    "THB": {
        "symbol": "฿",
        "nativeSymbol": "฿",
        "code": "THB",
    },
    "TND": {
        "symbol": "DT",
        "nativeSymbol": "د.ت.‏",
        "code": "TND",
    },
    "TOP": {
        "symbol": "T$",
        "nativeSymbol": "T$",
        "code": "TOP",
    },
    "TRY": {
        "symbol": "TL",
        "nativeSymbol": "TL",
        "code": "TRY",
    },
    "TTD": {
        "symbol": "TT$",
        "nativeSymbol": "$",
        "code": "TTD",
    },
    "TWD": {
        "symbol": "NT$",
        "nativeSymbol": "NT$",
        "code": "TWD",
    },
    "TZS": {
        "symbol": "TSh",
        "nativeSymbol": "TSh",
        "code": "TZS",
    },
    "UAH": {
        "symbol": "₴",
        "nativeSymbol": "₴",
        "code": "UAH",
    },
    "UGX": {
        "symbol": "USh",
        "nativeSymbol": "USh",
        "code": "UGX",
    },
    "UYU": {
        "symbol": "$U",
        "nativeSymbol": "$",
        "code": "UYU",
    },
    "UZS": {
        "symbol": "UZS",
        "nativeSymbol": "UZS",
        "code": "UZS",
    },
    "VEF": {
        "symbol": "Bs.F.",
        "nativeSymbol": "Bs.F.",
        "code": "VEF",
    },
    "VND": {
        "symbol": "₫",
        "nativeSymbol": "₫",
        "code": "VND",
    },
    "XAF": {
        "symbol": "FCFA",
        "nativeSymbol": "FCFA",
        "code": "XAF",
    },
    "XOF": {
        "symbol": "CFA",
        "nativeSymbol": "CFA",
        "code": "XOF",
    },
    "YER": {
        "symbol": "YR",
        "nativeSymbol": "ر.ي.‏",
        "code": "YER",
    },
    "ZAR": {
        "symbol": "R",
        "nativeSymbol": "R",
        "code": "ZAR",
    },
    "ZMK": {
        "symbol": "ZK",
        "nativeSymbol": "ZK",
        "code": "ZMK",
    },
    "ZWL": {
        "symbol": "ZWL$",
        "nativeSymbol": "ZWL$",
        "code": "ZWL",
    },
};
//# sourceMappingURL=CurrencyDetails.js.map